export var OrderPaymentType;
(function(OrderPaymentType) {
    OrderPaymentType[/**
     * A payment that is processed directly via the cinema payment server.
     *
     * @remarks
     * Used by clients that operate on a [[Site]] entity's internal network and require physical payment processing, such as a kiosk.
     */ "CinemaProcessed"] = "CinemaProcessed";
    OrderPaymentType[/**
     * A payment that is processed via an embedded payment client.
     */ "Embedded"] = "Embedded";
    OrderPaymentType[/**
     * A gift card payment.
     */ "GiftCard"] = "GiftCard";
    OrderPaymentType[/**
     * A payment that is processed via a third party payment website.
     */ "Redirect"] = "Redirect";
    OrderPaymentType[/**
     * A payment that is charged against a [[MemberBalance]].
     */ "MemberBalance"] = "MemberBalance";
})(OrderPaymentType || (OrderPaymentType = {}));

//# sourceMappingURL=order-payment-type.js.map